import { ASK_COLUMN, BID_COLUMN } from "../../service/producerServices/constants";
import { getDataFromMemoryTable } from "../../service/sourceServices";
import { LAST_VALUES } from "../constants";

let FIRST_RENDER = true;

export const setValuesToLastValuesObject = async (context: Excel.RequestContext) => {
  const sendedValues = await getDataFromMemoryTable(context);

  Object.keys(sendedValues).forEach((rowId) => {
    const { bid: bidValue, ask: askValue, row: rowNumber } = sendedValues[rowId] ?? {};

    if (!rowNumber) return;

    if (bidValue) LAST_VALUES[`${BID_COLUMN}${rowNumber}`] = { value: bidValue };
    if (askValue) LAST_VALUES[`${ASK_COLUMN}${rowNumber}`] = { value: askValue };
  });
};

export const getLastValuesFromSendedValues = async () => {
  if (!FIRST_RENDER) return;

  await Excel.run(async (context) => {
    await setValuesToLastValuesObject(context);

    FIRST_RENDER = false;
  });
};
